import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { ReportServices } from '../../../services/report.services';

/** SEND MESSAGE CHILD component */
import actions from './actions.store';
import getters from './getters.store';
import mutations from './mutations.store';
import { INotificationState, NotificationState } from './states.store';

/** define module */
export class NotificationModule<RootState> implements Module<INotificationState, RootState>{
  namespaced: boolean;
  state: INotificationState;
  getters: GetterTree<INotificationState, RootState>;
  actions: ActionTree<INotificationState, RootState>;
  mutations: MutationTree<INotificationState>;
  /**
   *
   */
  constructor() {
    this.namespaced = true;
    this.state = new NotificationState({ service: new ReportServices});

    this.mutations = {
      ...mutations,
    };

    this.actions = {
      ...actions,
    };

    this.getters = {
      ...getters,
    };
  }
}
